import { useT } from "../i18n/index";
import { Icon } from "../ui/icons";

// CUST-PORTFOLIO-UI — the Mesajlar surface. Previously a dead-end placeholder that the
// "Danışmana soru sor" (C0) and the profile advisor link pointed to. A native customer↔
// advisor messaging channel is a later slice (no party-realm messaging read/write yet), so
// this is an honest concierge stub — the promise + how to reach the advisor — not a fake
// inbox. Flagged backend-first: wire this to a messaging contract when it lands.
export function Messages() {
  const { t } = useT();
  return (
    <div className="stack" data-testid="messages">
      <div className="cx-pagehead">
        <div>
          <h1>{t("msg.title")}</h1>
          <p className="cx-pagehead__sub">{t("msg.body")}</p>
        </div>
      </div>
      <section className="cx-card">
        <div className="cx-card__head">
          <span className="cx-tile cx-tile--green" aria-hidden="true">
            <Icon name="conversation" size={22} />
          </span>
          <div className="cx-card__headmain">
            <span className="cx-card__title">{t("pf.advisorTitle")}</span>
            <span className="cx-card__sub" data-testid="msg-soon">
              {t("msg.soon")}
            </span>
          </div>
        </div>
      </section>
    </div>
  );
}
